import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { PreferencesModule } from './components/header/preferences/preferences.module';
import { HeaderModule } from './components/header/header.module';
import { SanitizeGooglePipe } from './pipes/sanitize-google.pipe';
import { DeliveryListModule } from './components/delivery-list/delivery-list.module';
import { ModalsModule } from './components/modals/modals.module';
import { HelpButtonModule } from './components/help-button/help-button.module';
import { MediaPipe } from './pipes/media.pipe';
import { SecurePipe } from './pipes/secure.pipe';

export const COMMON_MODULES = [
  CommonModule,
  IonicModule,
  HeaderModule,
  DeliveryListModule,
  HelpButtonModule,
  ModalsModule,
  PreferencesModule,
];

@NgModule({
  imports: [...COMMON_MODULES],
  declarations: [
     SanitizeGooglePipe, MediaPipe, SecurePipe
  ],
  exports: [...COMMON_MODULES, 
     SanitizeGooglePipe, MediaPipe, SecurePipe
  ],
})
export class SharedModule { }
